<template>
  <div class="rating-card-list-dropdown">
    <div
      v-if="loading"
      class="rating-card-list-dropdown__list"
      :style="gridTemplateColumns"
    >
      <div
        v-for="(n, index) in width"
        :key="'ajax__line-' + index"
        class="ajax__line -round-"
        :style="{ height: '80px', width: '100%', margin: '2px 0' }"
      />
    </div>
    <div
      v-else
      class="rating-card-list-dropdown__list"
      :style="gridTemplateColumns"
    >
      <div
        v-for="card in cardList"
        :key="card.id"
        class="rating-card-list-dropdown__item"
        :class="card.class"
        @click="openCard(card.id)"
      >
        <div class="rating-card-list-dropdown__content">
          <p class="rating-card-list-dropdown__title">
            {{ card.title }}
          </p>
          <p class="rating-card-list-dropdown__value">
            {{ card.value }}
            <Icon
              v-if="card.canOpen"
              class="rating-card-list-dropdown__arrow"
              icon="ui-down"
              :class="{ '-rotate-': value === card.id }"
            />
          </p>
        </div>
        <Icon class="rating-card-list-dropdown__icon" :icon="card.icon" />
        <div
          v-if="card.canOpen && value === card.id"
          class="rating-card-list-dropdown__opener-helper"
        />
      </div>
    </div>
    <DropdownOpener :values="cardList" :active-id="value" />
  </div>
</template>

<script>
import DropdownOpener from './components/DropdownOpener';

export default {
  components: {
    DropdownOpener
  },
  props: {
    value: {
      default: null
    },
    cardList: {},
    loading: {
      type: Boolean,
      default: false
    },
    width: {},
    nameClass: {},
    titleClass: {}
  },
  computed: {
    gridTemplateColumns() {
      if (this.width !== null && this.width !== undefined) {
        return {
          gridTemplateColumns: `repeat(auto-fit, minmax(${this.width}, 1fr))`
        };
      }
      return undefined;
    }
  },
  methods: {
    openCard(id) {
      if (this.value === id) {
        this.$emit('input', null);
      } else {
        this.$emit('input', id);
      }
    }
  }
};
</script>
